"use client";

import { defaultLocale } from "@/libs/config/locale";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import Cookies from "js-cookie";

const useLocale = () => {
  const pathname = usePathname();

  const currentLocale = Cookies.get("NEXT_LOCALE");

  return useMemo(() => currentLocale ?? defaultLocale, [pathname]);
};
export default useLocale;
